module.exports = __webpack_public_path__ + "img/ufo-silhouette.f2ffbfef.webp";